module.exports = __webpack_public_path__ + "static/media/search-icon-aqua-blue.71601bb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search-icon-aqua-blue.svg
// module id = 391
// module chunks = 1